import { FaLinkedin, FaGithubSquare } from "react-icons/fa";
import './App.css';

function App() {
  return (
    <div className="bg-white w-screen h-screen grid place-content-center text-lg">
      <h1 className='text-gray-600 text-center font-bold'>Callum Fortune</h1>
      <h2 className='text-gray-600 text-center'>Software engineer, Cheshire</h2>
      <h2 className='text-gray-600 text-center mt-4 pt-4 border-t'>callum@seefortune.co.uk</h2>
      <div className='mt-4 text-center flex justify-center gap-4'>
        <a href="https://www.linkedin.com/in/callumfortune" target="_blank" rel="noopener noreferrer" className='text-gray-600 text-[50px]'>
          <FaLinkedin />
        </a>
        
        <a href="https://www.github.com/callumjamesfortune" target="_blank" rel="noopener noreferrer" className='text-gray-600 text-[50px]'>
          <FaGithubSquare />
        </a>

      </div>
    </div>
  );
}

export default App;
